/* lua.js generated code 0.3.0 */

HomeSceneBottomBtnAnim = xClass("HomeSceneBottomBtnAnim")
HomeSceneBottomBtnAnim.prototype.ctor = function (button) {
    var self = this
    self.downHandler = null
    self.moveInHander = null
    self.moveOutHandler = null
    self.upHandler = null
    self.upOutHandler = null
    self.button = button
    var bg = self.button.getChildByName("bg")
    if (bg) {
        self.bgScale = cc.p(bg.getScaleX(), bg.getScaleY())
    }
    var icon = self.button.getChildByName("icon")
    if (icon) {
        self.iconScale = cc.p(icon.getScaleX(), icon.getScaleY())
    }
    var txt = self.button.getChildByName("txt")
    if (txt) {

        // 现在字体 有可能不是BMFont，是使用 FONT_DEF 生成的，所以可能不存在各种函数
        txt.ignoreContentAdaptWithSize && txt.ignoreContentAdaptWithSize(true)
        self.txtScale = cc.p(txt.getScaleX(), txt.getScaleY())
        if (txt.getVirtualRendererSize) {
            var size = txt.getVirtualRendererSize()
            txt.setAnchorPoint(cc.p(0.5, 0.5))
            txt.setPosition(cc.p(0, txt.getPositionY() - size.height * self.txtScale.y / 2))
        }
    }
    self.useAnim()
}
HomeSceneBottomBtnAnim.prototype.useAnim = function () {
    var self = this
    var listening = false
    function onBounceEnable() {
        if (listening) {
            return 
        }
        listening = true
        var bg = self.button.getChildByName("bg")
        if (bg && self.bgScale) {
            bg.runAction(cc.Sequence.create(cc.DelayTime.create(0.08), cc.ScaleTo.create(0.16, 0.9 * self.bgScale.x, 0.9 * self.bgScale.y), cc.ScaleTo.create(0.125, self.bgScale.x, self.bgScale.y)))
        }
        var icon = self.button.getChildByName("icon")
        if (icon && self.iconScale) {
            icon.runAction(cc.Sequence.create(cc.ScaleTo.create(0.16, 0.9 * self.iconScale.x, 0.9 * self.iconScale.y), cc.ScaleTo.create(0.125, self.iconScale.x, self.iconScale.y)))
        }
        var txt = self.button.getChildByName("txt")
        if (txt && self.txtScale) {
            txt.runAction(cc.Sequence.create(cc.DelayTime.create(0.04), cc.ScaleTo.create(0.16, 0.9 * self.txtScale.x, 0.9 * self.txtScale.y), cc.ScaleTo.create(0.125, self.txtScale.x, self.txtScale.y)))
        }
    }
    function onBounceDisable() {
        if (!listening) {
            return 
        }
        listening = false
    }
    var useless
    [useless, self.downHandler] = self.button.on(UIButtonEvent.Down, onBounceEnable)
    [useless, self.moveInHander] = self.button.on(UIButtonEvent.MoveIn, onBounceEnable)
    [useless, self.upHandler] = self.button.on(UIButtonEvent.Click, onBounceDisable)
    [useless, self.moveOutHandler] = self.button.on(UIButtonEvent.MoveOut, onBounceDisable)
    [useless, self.upOutHandler] = self.button.on(UIButtonEvent.UpOutside, onBounceDisable)
}
HomeSceneBottomBtnAnim.prototype.removeAnim = function () {
    var self = this
    self.button.removeEventListener(self.downHandler)
    self.button.removeEventListener(self.moveInHander)
    self.button.removeEventListener(self.moveOutHandler)
    self.button.removeEventListener(self.upHandler)
    self.button.removeEventListener(self.upOutHandler)
}
module.exports = HomeSceneBottomBtnAnim
